import McpServersAPI from '../../api/mcpServers';

const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
    isTesting: false,
    isSyncing: false,
  },
  serverTypes: {},
  categories: {},
  serverTypesByCategory: {},
};

const getters = {
  getMcpServers: $state => $state.records,
  getMcpServerById: $state => id =>
    $state.records.find(s => s.id === Number(id)),
  getMcpServersByType: $state => type =>
    $state.records.filter(s => s.server_type === type),
  getMcpServersByCategory: $state => category =>
    $state.records.filter(s => s.category === category),
  getActiveMcpServers: $state => $state.records.filter(s => s.is_active),
  getUIFlags: $state => $state.uiFlags,
  getServerTypes: $state => $state.serverTypes,
  getCategories: $state => $state.categories,
  getServerTypesByCategory: $state => $state.serverTypesByCategory,
};

const actions = {
  async fetchMcpServers({ commit }) {
    commit('SET_UI_FLAG', { isFetching: true });
    try {
      const response = await McpServersAPI.get();
      commit('SET_MCP_SERVERS', response.data.mcp_servers);
      commit('SET_SERVER_TYPES', response.data.server_types);
      commit('SET_CATEGORIES', response.data.categories);
    } finally {
      commit('SET_UI_FLAG', { isFetching: false });
    }
  },

  async fetchServerTypes({ commit }) {
    const response = await McpServersAPI.getServerTypes();
    commit('SET_SERVER_TYPES', response.data.types);
    commit('SET_CATEGORIES', response.data.categories);
    commit('SET_SERVER_TYPES_BY_CATEGORY', response.data.by_category);
    return response.data;
  },

  async createMcpServer({ commit }, mcpServer) {
    commit('SET_UI_FLAG', { isCreating: true });
    try {
      const response = await McpServersAPI.create(mcpServer);
      commit('ADD_MCP_SERVER', response.data);
      return response.data;
    } finally {
      commit('SET_UI_FLAG', { isCreating: false });
    }
  },

  async updateMcpServer({ commit }, { id, ...data }) {
    commit('SET_UI_FLAG', { isUpdating: true });
    try {
      const response = await McpServersAPI.update(id, data);
      commit('UPDATE_MCP_SERVER', response.data);
      return response.data;
    } finally {
      commit('SET_UI_FLAG', { isUpdating: false });
    }
  },

  async deleteMcpServer({ commit }, id) {
    commit('SET_UI_FLAG', { isDeleting: true });
    try {
      await McpServersAPI.delete(id);
      commit('REMOVE_MCP_SERVER', id);
    } finally {
      commit('SET_UI_FLAG', { isDeleting: false });
    }
  },

  async testConnection({ commit }, id) {
    commit('SET_UI_FLAG', { isTesting: true });
    try {
      const response = await McpServersAPI.testConnection(id);
      return response.data;
    } finally {
      commit('SET_UI_FLAG', { isTesting: false });
    }
  },

  async syncTools({ commit }, id) {
    commit('SET_UI_FLAG', { isSyncing: true });
    try {
      const response = await McpServersAPI.syncTools(id);
      commit('UPDATE_MCP_SERVER', response.data);
      return response.data;
    } finally {
      commit('SET_UI_FLAG', { isSyncing: false });
    }
  },
};

const mutations = {
  SET_UI_FLAG($state, data) {
    $state.uiFlags = { ...$state.uiFlags, ...data };
  },

  SET_MCP_SERVERS($state, mcpServers) {
    $state.records = mcpServers;
  },

  SET_SERVER_TYPES($state, types) {
    $state.serverTypes = types;
  },

  SET_CATEGORIES($state, categories) {
    $state.categories = categories;
  },

  SET_SERVER_TYPES_BY_CATEGORY($state, data) {
    $state.serverTypesByCategory = data;
  },

  ADD_MCP_SERVER($state, mcpServer) {
    $state.records.push(mcpServer);
  },

  UPDATE_MCP_SERVER($state, mcpServer) {
    const index = $state.records.findIndex(s => s.id === mcpServer.id);
    if (index !== -1) {
      $state.records.splice(index, 1, mcpServer);
    }
  },

  REMOVE_MCP_SERVER($state, id) {
    $state.records = $state.records.filter(s => s.id !== id);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
